module.exports.backend = {
    apiUrl: "https://dev.swift-vmarket.venturing.com.ar/Swift-vMarket/api",
};

module.exports.captcha = "6Les9uQnAAAAAFfM9IxW09fm0UAuYq1fGv76lYGA";